import lodash from 'lodash';
import { APP_LANGUAGE } from 'commons/models/common';
import {
	IZupeeKheloJeetoUploadQnA,
	ICsvToJson,
	IZupeeKheloJeetoUploadQuestions,
	IZupeeKheloJeetoQuestion,
	IZupeeKheloJeetoAnswers,
	IZupeeKheloJeetoUploadAnswers,
	IZUpeeKheloJeetoUploadQuestionFormat
} from '../model';

export const ZKJ_UPLOAD_Q_A_OPTIONS = {
	addQuestions: 'addQuestions',
	addAnswers: 'addAnswers'
};

const prefixes = ['A: ', 'B: ', 'C: ', 'D: '];

export const actionOptions = [
	{ label: 'Add Questions', id: ZKJ_UPLOAD_Q_A_OPTIONS.addQuestions },
	{ label: 'Add Answers', id: ZKJ_UPLOAD_Q_A_OPTIONS.addAnswers }
];

export const toInteger = (num: string) => {
	return parseInt(num, 10);
};

const getConstraintId = (team1: string, team2: string, date: string, phase: string) => {
	return `${team1}_${team2}_${date}_${phase}`;
};

const transformData = (input: IZupeeKheloJeetoUploadQuestions): IZupeeKheloJeetoUploadQnA => {
	const result: IZupeeKheloJeetoUploadQnA = {
		constraintId: input.constraintId,
		questions: {
			en: [],
			hi: []
		}
	};

	input.questions.forEach((question) => {
		const enQuestion: IZupeeKheloJeetoQuestion = {
			id: question.id,
			text: question.text[APP_LANGUAGE.ENGLISH],
			options: question.options.map((option, index) => ({
				id: option.id,
				text: prefixes[index] + option.text[APP_LANGUAGE.ENGLISH]
			})),
			questionPoints: question.questionPoints
		};

		const hiQuestion: IZupeeKheloJeetoQuestion = {
			id: question.id,
			text: question.text[APP_LANGUAGE.HINDI],
			options: question.options.map((option, index) => ({
				id: option.id,
				text: prefixes[index] + option.text[APP_LANGUAGE.HINDI]
			})),
			questionPoints: question.questionPoints
		};

		result.questions[APP_LANGUAGE.ENGLISH].push(enQuestion);
		result.questions[APP_LANGUAGE.HINDI].push(hiQuestion);
	});

	return result;
};

export const prepareZkjContestDetails = (jsonData: ICsvToJson[]) => {
	try {
		const contestDetails: IZupeeKheloJeetoUploadQuestions = {} as IZupeeKheloJeetoUploadQuestions;
		const questions: IZUpeeKheloJeetoUploadQuestionFormat[] = [] as IZUpeeKheloJeetoUploadQuestionFormat[];
		for (let i = 0; i < jsonData.length; i += 1) {
			const question = {} as IZUpeeKheloJeetoUploadQuestionFormat;
			if (i === 0) {
				contestDetails.constraintId = getConstraintId(
					jsonData[0].TEAM_1,
					jsonData[0].TEAM_2,
					jsonData[0].DATE,
					jsonData[0].PHASE
				);
			}
			if (jsonData[i].QUESTION_TEXT) {
				question.id = i + 1;
				question.text = JSON.parse(jsonData[i].QUESTION_TEXT);
				question.questionPoints = toInteger(jsonData[i].QUESTION_POINTS);
				let k = 1;
				const options = [];
				while (jsonData[i][`OPTION_${k}`]) {
					options.push({
						id: k,
						text: JSON.parse(`${jsonData[i][`OPTION_${k}`]}`)
					});
					k += 1;
				}
				if (!lodash.isEmpty(options)) {
					question.options = options;
				}
				questions.push(question);
			}
		}
		if (!lodash.isEmpty(questions)) {
			contestDetails.questions = questions;
		}
		const questionDetails = transformData(contestDetails);
		return questionDetails;
	} catch (error) {
		throw new Error(`Error while uploading questions csv ${error}`);
	}
};

export const prepareZkjAnswerDetails = (jsonData: ICsvToJson[]) => {
	try {
		const contestDetails: IZupeeKheloJeetoUploadAnswers = {} as IZupeeKheloJeetoUploadAnswers;
		const answers: IZupeeKheloJeetoAnswers = {} as IZupeeKheloJeetoAnswers;
		for (let i = 0; i < jsonData.length; i += 1) {
			if (i === 0) {
				contestDetails.constraintId = getConstraintId(
					jsonData[0].TEAM_1,
					jsonData[0].TEAM_2,
					jsonData[0].DATE,
					jsonData[0].PHASE
				);
			}
			if (jsonData[i].ANSWER) {
				const key = String(i + 1);
				answers[key] = Number(jsonData[i].ANSWER);
			}
		}
		contestDetails.answers = answers;
		return contestDetails;
	} catch (error) {
		throw new Error(`Error while uploading answers csv ${error}`);
	}
};
